import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '@shoelace-style/shoelace/dist/components/select/select.js';
import '@shoelace-style/shoelace/dist/components/option/option.js';
import type { SlSelect } from '@shoelace-style/shoelace';
import assert from 'assert'

interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

@customElement('vxc-select')
export class CustomSelect extends LitElement {
    @property({ type: String   , attribute: 'name'        }) name: string = '';
    @property({ type: Array   , attribute: 'items'       }) options: SelectOption[] = [];
    @property({ type: String  , attribute: 'value'       }) value: string = '';
    @property({ type: Boolean , attribute: 'multiple'    }) multiple: boolean = false;
    @property({ type: String  , attribute: 'label'       }) label: string = '';
    @property({ type: String  , attribute: 'placeholder' }) placeholder: string = 'Select an option';
    @property({ type: String  , attribute: 'size'        }) size: 'small' | 'medium' | 'large' = 'medium';
    @property({ type: String  , attribute: 'storage'     }) storage: string = '';

    private handleChange(event: Event) {
		try  {
			if(!this.storage)	return
			const select  = event.target as SlSelect;
			const values  = select.value;
			const option  = this.options.find( o => o.value === values )
			const labels  = option?.label || values
			var selected  = `${labels}:${values}`
			const payload = { label: labels, value: values }

			console.log('Selected :', selected);
			// store to storage
			assert(this.name, 'attribute "name" not set..')
			if(this.storage === 'session') {
				sessionStorage.setItem(this.name, selected)
				this.dispatchEvent(new CustomEvent(`${this.name}.set`, {
					detail: payload,
					bubbles: true,
					composed: true
				}))
			}
			// dispatch event
			this.dispatchEvent(new CustomEvent('selected', {
				detail: payload,
				bubbles: true,
				composed: true
			}))
		}
		catch(e) { console.error(e) }
    }

    firstUpdated(changedProperties: Map<string | number | symbol, unknown>) {
      	super.firstUpdated(changedProperties);
		try {
			if(!this.storage)	return
			if(this.storage === 'session') {
				assert(this.name, 'attribute "name" not set..')
				const stored = sessionStorage.getItem(this.name)
				const values = stored?.split(':')[1] || this.value
				this.value = values
				console.log('stored', stored)
			}
		} 
		catch(e) { console.error(e) }
    }

    render() {
		console.log('render', this.value, this.options)
        return html`
            <sl-select
                placeholder=${this.placeholder}
                size=${this.size}
                ?multiple=${this.multiple}
                value=${this.value}
				label=${this.label}
                @sl-change=${this.handleChange}
            >
            ${this.options.map(option => html`
                <sl-option
                    value=${option.value}
                    ?disabled=${option.disabled}
                >
                    ${option.label}
                </sl-option>`)}
      		</sl-select>
    `;
  }
}

declare global {
	interface HTMLElementTagNameMap {
		'vxc-select': CustomSelect;
	}
}